import { useState, useEffect } from "react"

const useInstagramImages = () => {
  const [images, setImages] = useState([])

  useEffect(() => {
    const fetchImages = async () => {
      try {
        const apiResponse = await fetch(`/.netlify/functions/instagram-feed`, {
          method: "GET",
        })
        const data = await apiResponse.json()
        setImages(data || [])
      } catch (error) {
        console.error("Couldn't fetch Instagram images:", error)
        setImages([])
      }
    }
    fetchImages()
  }, [setImages])

  return images
}

export default useInstagramImages
